import { dateRangePickerFields } from "../../filters/components/DateRangePicker";
import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Payment",
    type: FILTER_TYPES.Switch,
    defaultValue: "",
    fields: "deposit_received",
    options: [
      { label: "All", value: "" },
      { label: "Paid", value: "true" },
      { label: "Not Paid", value: "false" },
    ],
    flexBasis: 250,
    containerStyle: {
      minWidth: "250px"
    }
  },
  {
    label: "Date Paid",
    type: FILTER_TYPES.DateRange,
    fields: ["category_date_paid", "start_date_paid", "end_date_paid"],
    defaultValue: ["", "", ""],
  },
  {
    label: "Order Date",
    type: FILTER_TYPES.DateRange,
    fields: ["category_order_date", "start_order_date", "end_order_date"],
    defaultValue: ["", "", ""],
  },
  {
    label: "Client",
    type: FILTER_TYPES.Client,
    fields: "client_id",
  },
  {
    label: "Order Rep",
    type: FILTER_TYPES.User,
    fields: ["sales_rep_id", "sales_rep_team_ids", "include_inactive_sales_reps"],
  },
  {
    label: "Project",
    fields: "project_search",
    type: FILTER_TYPES.Query,
    fetchReportOnEnterPress: true,
  },
];
